import { HttpClient } from 'api/helpers/HttpClient';
import { CONTENT_DATA_PATH_SERVICE } from 'api/services/content/paths';
import { getPurchaseButtonInfo as fetchPurchaseButtonInfo } from 'services/api/payway/purchaseButtonInfo';
import { redirect } from 'react-router-dom';
import { getRegion } from 'utils/Region';
import {
  fetchInfoSerie,
  fetchSerieSeenLast,
} from '../../services/content.service';
import {
  GET_CONTENT_INIT,
  GET_CONTENT_SUCCESS,
  GET_CONTENT_ERROR,
  GET_CONTENT_SERIE_ERROR,
  GET_CONTENT_SERIE_INIT,
  GET_CONTENT_SERIE_SUCCESS,
  GET_CONTENT_PBI_INIT,
  GET_CONTENT_PBI_SUCCESS,
  GET_CONTENT_PBI_ERROR,
  CLEAR_VCARD_DATA,
  GET_SEEN_LAST,
  CLEAR_SEEN_LAST,
  GET_SEEN_LAST_INIT,
  CLEAR_CONTENT_PBI,
} from './constants';
import { purchaseButtonInfoService } from 'api/services/payway';

//WIP: BIFUR
export const getContentByGroupId = (
  groupId,
  claroAdEnable,
) => async dispatch => {
  const getContentRequested = () => ({
    type: GET_CONTENT_INIT,
  });

  const getContentSucceeded = ({ response }) => ({
    type: GET_CONTENT_SUCCESS,
    response,
  });

  const getContentFailed = e => ({
    type: GET_CONTENT_ERROR,
    error: e,
  });
  try {
    dispatch(getContentRequested());
    const apiCall = new HttpClient({ hasClaroAdActive: claroAdEnable });
    const url = claroAdEnable
      ? CONTENT_DATA_PATH_SERVICE
      : 'services/content/data';

    const { data: contentResp } = await apiCall.get(url, { group_id: groupId });
    dispatch(getContentSucceeded(contentResp));
  } catch (error) {
    console.log(error);
    dispatch(getContentFailed(error));
  }
};

export const getInfoSerieByGroupId = groupId => {
  const getInfoSerieByGroupRequested = () => ({
    type: GET_CONTENT_SERIE_INIT,
  });

  const getInfoSerieByGroupSucceeded = ({ response }) => ({
    type: GET_CONTENT_SERIE_SUCCESS,
    response: { ...response, groupId },
  });

  const getInfoSerieByGroupFailed = e => ({
    type: GET_CONTENT_SERIE_ERROR,
    error: e,
  });

  return dispatch => {
    dispatch(getInfoSerieByGroupRequested());
    return fetchInfoSerie({ group_id: groupId })
      .then(content => dispatch(getInfoSerieByGroupSucceeded(content.data)))
      .catch(error => dispatch(getInfoSerieByGroupFailed(error)));
  };
};
export const clearPbiInfo = () => ({
  type: CLEAR_CONTENT_PBI,
});

export const getPurchaseButtoninfoByGroupId = (groupId, claroLiteConfig) => {
  const purchaseRequested = () => ({
    type: GET_CONTENT_PBI_INIT,
  });

  const purchaseSucceeded = response => ({
    type: GET_CONTENT_PBI_SUCCESS,
    response: { ...response, groupId },
  });

  const purchaseFailed = e => ({
    type: GET_CONTENT_PBI_ERROR,
    error: e,
  });

  return dispatch => {
    dispatch(purchaseRequested());
    return purchaseButtonInfoService({
      group_id: groupId,
      claroAdEnable: claroLiteConfig?.enable || false,
    })
      .then(({ data }) => {
        dispatch(purchaseSucceeded(data.response));
      })
      .catch(error => dispatch(purchaseFailed(error)));
  };
};

export const clearVCardData = () => ({
  type: CLEAR_VCARD_DATA,
});

//---- seen last ----
export const getSeenLast = ({ group_id, serieId, navigate }) => async (
  dispatch,
  getState,
) => {
  dispatch({ type: GET_SEEN_LAST_INIT });
  const {
    user: { userhash },
    metadata: { byr_filterlist_configuration },
  } = getState();
  const anonymousUserComeFromPlayer = JSON.parse(
    localStorage.getItem('anonymousUserComeFromPlayer'),
  );

  try {
    const { data: seenLastResponse } = await fetchSerieSeenLast({
      group_id,
      user_hash: userhash,
      lasttouch: localStorage.getItem('lasttouchSeen'),
      filterlist: JSON.parse(byr_filterlist_configuration)[getRegion()]
        .filterlist,
    });

    if (!seenLastResponse?.response)
      throw new Error(seenLastResponse?.errors?.code);

    dispatch({
      type: GET_SEEN_LAST,
      payload: { seenLast: seenLastResponse.response, serieId },
    });

    if (
      group_id !== seenLastResponse.response.episode.id &&
      !anonymousUserComeFromPlayer
    ) {
      navigate(
        `/${getRegion()}/vcard/homeuser/${encodeURIComponent(
          seenLastResponse.response.serie.title,
        )}/${seenLastResponse.response.episode.id}`,
      );
    }
  } catch (error) {
    dispatch({
      type: GET_SEEN_LAST,
      payload: { seenLast: {}, serieId },
    });
  }
};

export const clearSeenlast = () => dispatch =>
  dispatch({ type: CLEAR_SEEN_LAST });
